/* eslint-disable @typescript-eslint/no-explicit-any */

import * as React from "react";
import { EventResource } from "client/resources/eventResource";
import DateFormatter from "utils/DateFormatter/DateFormatter";
import { EventFormatter } from "components/EventFormatter/EventFormatter";
import SimpleDataTable from "../../../../components/SimpleDataTable/SimpleDataTable";
import ToolTip from "../../../../components/ToolTip/ToolTip";
import { Errors } from "components/DataBaseComponent";
import { repository } from "clientInstance";
import PaperLayout from "components/PaperLayout";
import { isAllowed } from "components/PermissionCheck/PermissionCheck";
import { Permission } from "client/resources/permission";
import DataLoader from "components/DataLoader";
import { NotPermittedToViewEventsCallout } from "components/EventListing/EventListing";
import { TaskResource } from "client/resources";
const styles = require("./history.less");

interface HistoryProps {
    task: TaskResource<any>;
    projectId: string | undefined;
    environmentId: string | undefined;
    tenantId: string | undefined;
}

class HistoryTable extends SimpleDataTable<EventResource> {}
const HistoryDataLoader = DataLoader<{ events: EventResource[] }>();

export const HistoryForTask: React.FC<HistoryProps> = (props) => {
    const permitEvents: boolean = isAllowed({
        permission: Permission.EventView,
        project: props.projectId,
        environment: props.environmentId,
        tenant: props.tenantId,
    });

    const loadEvents = async () => {
        const events = await repository.Events.list({ regardingAny: [props.task.Id] });
        return { events: events.Items };
    };

    const displayHistoryTable = (data: EventResource[]) => {
        return data.length > 0 ? (
            <HistoryTable
                rowColumnClassName={styles.row}
                data={data}
                headerColumns={["When", "Who", "What"]}
                headerColumnClassNames={[styles.row, styles.row, styles.row]}
                onRow={(event) => [
                    <ToolTip content={DateFormatter.dateToShortFormat(event.Occurred) || undefined}>
                        <div style={{ minWidth: "5rem" }}>{DateFormatter.momentAgo(event.Occurred)}</div>
                    </ToolTip>,
                    event.Username,
                    <EventFormatter event={event} />,
                ]}
            />
        ) : (
            <div>{"There is no data to show"}</div>
        );
    };

    const showLoadingAndBusyState = (busy: boolean, errors: Errors | undefined) => {
        return <PaperLayout busy={busy} errors={errors} />;
    };

    return (
        <div className={styles.container}>
            <h4>Task History</h4>
            {permitEvents ? <HistoryDataLoader load={loadEvents} renderWhenLoaded={(data) => displayHistoryTable(data.events)} renderAlternate={({ busy, errors }) => showLoadingAndBusyState(busy, errors)} /> : <NotPermittedToViewEventsCallout />}
        </div>
    );
};
